var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart" }, [
    _vm.totalItems > 0
      ? _c(
          "div",
          { key: "contents", staticClass: "cart__contents" },
          [
            _c("div", { staticClass: "cart-title-wrapper" }, [
              _c("h1", { staticClass: "cart__title h3" }, [
                _vm._v("Shopping Cart"),
              ]),
              _vm.$mq !== "mobile"
                ? _c(
                    "a",
                    {
                      staticClass: "cart__title-link",
                      attrs: { href: _vm.emptyButtonLink },
                    },
                    [_vm._v("Continue Shopping")]
                  )
                : _vm._e(),
            ]),
            _vm._l(_vm.items, function (item, index) {
              return _c("sidecart-line-item", {
                key: item.id,
                attrs: { item: item, line: index + 1 },
              })
            }),
          ],
          2
        )
      : _c(
          "div",
          { key: "empty", staticClass: "cart__empty" },
          [
            _c("h1", { staticClass: "cart__title h3" }, [
              _vm._v("Shopping Cart"),
            ]),
            _c("p", { staticClass: "cart__empty__text" }, [
              _vm._v(_vm._s(_vm.emptyText)),
            ]),
            _c("link-button", {
              attrs: { href: _vm.emptyButtonLink, label: _vm.emptyButtonText },
            }),
          ],
          1
        ),
    _vm.totalItems > 0
      ? _c(
          "div",
          { staticClass: "cart__sidebar" },
          [
            _c("p", { staticClass: "cart__total" }, [
              _vm._v("Subtotal:"),
              _c("span", { staticClass: "cart__total-amount" }, [
                _vm._v(_vm._s(_vm._f("money")(_vm.totalPrice))),
              ]),
            ]),
            _c("checkout-button", {
              staticClass: "cart__checkout-cta",
              attrs: { label: "Checkout", name: "checkout" },
            }),
            _c("div", { staticClass: "cart__free-shipping" }, [
              _vm._v(_vm._s(_vm.freeShippingBarContent)),
            ]),
            _vm.$mq === "mobile"
              ? _c(
                  "a",
                  {
                    staticClass: "cart__keep-shopping-link",
                    attrs: { href: _vm.emptyButtonLink },
                  },
                  [_vm._v("Continue Shopping")]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }